import FootballState from "../../../../state/football-state";
import RushFieldChange from "../../../offensive/rush/rush-field-change";

export default class FieldGoalFakeRunFieldChange extends RushFieldChange {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.FieldGoalFakeRun;
    }
}
